import { observable } from "mobx";
import ChargePropertyChangeDisplayType from "./chargePropertyChangeDisplayType";
import { Type } from "class-transformer";
import ChargeChangeInitiator from "./chargeChangeInitiator";
import ChargeChangeOrigin from "./chargeChangeOrigin";
import VehicleRegisterVehicleChange from "./vehicleRegisterVehicleChange";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeChange {
  @observable
  @Type(() => Date)
  changedAt!: Date;

  @observable
  changeType!: ChargePropertyChangeDisplayType;

  @observable
  originalValue?: string;

  @observable
  newValue?: string;

  @observable
  @Type(() => VehicleRegisterVehicleChange)
  originalVehicleRegisterVehicle?: VehicleRegisterVehicleChange;

  @observable
  @Type(() => VehicleRegisterVehicleChange)
  newVehicleRegisterVehicle?: VehicleRegisterVehicleChange;

  @observable
  changeInitiator!: ChargeChangeInitiator;

  @observable
  changedBy?: string;

  @observable
  changeOrigin!: ChargeChangeOrigin;

  @observable
  officialRecordId?: string;

  @observable
  wasMadeByCustomerDuringValidity!: boolean;

  @observable
  _showDetail: boolean = true;
}
